import React from 'react'
import { useSelector } from 'react-redux'

import { dispatchSetMessagesTabOpen } from 'store/dispatcher'
import { _isMessagesTabOpen } from 'store/selectors/Chat'

import {
    ChatHeaderContainer,
    BackButtonContainer,
    BackButtonImg,
    HeaderSliderContainer,
    SliderTab,
} from './styles'

const ChatHeader = ({ handleHideChat }) => {
    const isMessagesTabOpen = useSelector(_isMessagesTabOpen)
    const setMessagesTabActive = () => {
        dispatchSetMessagesTabOpen(true)
    }

    const setMessagesTabInactive = () => {
        dispatchSetMessagesTabOpen(false)
    }

    return (
        <ChatHeaderContainer>
            <BackButtonContainer onClick={handleHideChat}>
                <BackButtonImg src="/assets/arrow_back.svg" alt="back-button" />
            </BackButtonContainer>
            <HeaderSliderContainer>
                <SliderTab
                    onClick={setMessagesTabActive}
                    isActive={isMessagesTabOpen}
                >
                    Messages
                </SliderTab>
                <SliderTab
                    onClick={setMessagesTabInactive}
                    isActive={!isMessagesTabOpen}
                >
                    All
                </SliderTab>
            </HeaderSliderContainer>
        </ChatHeaderContainer>
    )
}

export default React.memo(ChatHeader)
